import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IPosition } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class PositionService extends BaseService<IPosition> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'position');
  }
}

export { IPosition, PositionType } from '../shared/api';
